/**
 * Strips HTML tags from a string using regex.
 * (Named export: import { cleanText } from './textHelpers')
 */
export function cleanText(rawDirtyHTML) {
  if (!rawDirtyHTML) return '';
  return rawDirtyHTML.replace(/<[^>]*>/g, '');
}

/**
 * Strips HTML safely using the DOM and truncates the string to a specified word limit.
 * (Default export: import renderPlainTextDescription from './textHelpers')
 */
export default function renderPlainTextDescription(htmlText, limit) {
  if (!htmlText) return '';
  
  // Create a temporary element to strip HTML tags safely
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlText;
  const plainText = tempDiv.textContent || tempDiv.innerText || "";

  // Truncate by word count
  const words = plainText.split(' ');
  return words.length > limit ? words.slice(0, limit).join(' ') + '...' : plainText;
}